export default "__VITE_ASSET__Cb5u5FYF__"